<template>
  <div>
    ORg Summary
  </div>
</template>

<script>
export default {

}
</script>
